import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
export function API0() {
  const api = axios.create({ baseURL: process.env.REACT_APP_EXPERT_BASE_URL });
  api.defaults.headers.post["Content-Type"] = "application/json ";
  api.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  api.defaults.withCredentials = true;

  api.interceptors.response.use(
    (res) => {
      return res.data;
    },
    (error) => {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        window.location.href = "/login";
      } else {
        const errorMessage = error?.response?.data?.errors[0]?.message;
        toast.error(errorMessage);
      }
    }
  );

  return api;
}

function API1() {
  const api = axios.create({ baseURL: process.env.REACT_APP_EXPERT_BASE_URL });
  api.defaults.headers.post["Content-Type"] = "application/json ";
  api.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  api.defaults.withCredentials = true;

  api.interceptors.response.use(
    (res) => {
      return res.data;
    },
    (error) => {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        window.location.href = "/login";
      } else {
        const errorMessage = error?.response?.data?.errors[0]?.message;
        toast.error(errorMessage);
      }
    }
  );

  return api;
}

export function API2() {
  const api = axios.create({ baseURL: process.env.REACT_APP_EXPERT_BASE_URL });
  api.defaults.headers.post["Content-Type"] = "application/json ";
  api.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  api.defaults.withCredentials = true;

  api.interceptors.response.use(
    (res) => {
      return res.data;
    },
    (error) => {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        window.location.href = "/login";
      } else {
        const errorMessage = error?.response?.data?.errors[0]?.message;
        toast.error(errorMessage);
      }
    }
  );

  return api;
}

export async function login(data) {
  const response = await API1().post("/auth/login", data);
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data?.profile;
  } else {
    throw Error();
  }
}

export async function getStatistics() {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API0().get(`/experts/${expertId}/statics`);
  return response?.result?.data;
}

export async function filterFarmers(
  fullName,
  phoneNumber,
  provinceId,
  cityId,
  productId,
  marked,
  sort
) {
  let params = {};
  if (fullName) params["fullName"] = fullName;
  if (phoneNumber) params["phoneNumber"] = phoneNumber;
  if (provinceId) params["provinceId"] = provinceId;
  if (cityId) params["cityId"] = cityId;
  if (productId) params["productId"] = productId;
  if (marked) params["marked"] = marked;
  if (sort) params["sort"] = sort;
  // if(orderBy)params['sort'] = 1

  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API0().get(`/experts/${expertId}/farmers`, {
    params: params,
  });
  params = {};
  return response?.result?.data?.farmers;
}

export async function setfarmerMarked({ farmerId, marked }) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API0().put(
    `/experts/${expertId}/farmers/${farmerId}`,
    { marked: marked }
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function getSelectedFarmer(farmerId) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API0().get(`/experts/${expertId}/farmers/${farmerId}`);
  return response?.result?.data;
}

export async function getProfessionsAndSkills() {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API0().get(`/experts/${expertId}/skills`);
  return response?.result?.data?.skills;
}

export async function sendFileName(data) {
  const response = await API0().post("/files/s3-upload-file", data);
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result.data;
  } else {
    throw Error();
  }
}

export async function sendFile({ body, url }) {
  const response = await axios.post(url, body);
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function createProfessionsAndSkills(data) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().post(`/experts/${expertId}/skills`, data);

  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function editProfessionsAndSkills({ body, skillId }) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().put(
    `/experts/${expertId}/skills/${skillId}`,
    body
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function editRejectedProfessionAndSkill({ body, skillId }) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().put(
    `/experts/${expertId}/skills-updates/${skillId}`,
    body
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function deleteProfessionsAndSkills(skillId) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().delete(
    `/experts/${expertId}/skills/${skillId}`
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function cancelModifiedProfessionAndSkillUpdate(skillId) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().delete(
    `/experts/${expertId}/skills-updates/${skillId}`
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function createExpertArticles(data) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().post(`/experts/${expertId}/contents`, data);
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function editExpertArticle({ body, contentId }) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().put(
    `/experts/${expertId}/contents/${contentId}`,
    body
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function editRejectedExpertArticle({ body, contentId }) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().put(
    `/experts/${expertId}/contents-updates/${contentId}`,
    body
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function cancelModifiedArticleUpdate(contentId) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().delete(
    `/experts/${expertId}/contents-updates/${contentId}`
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function createExpertVideos(data) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().post(`/experts/${expertId}/contents`, data);
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function editExpertVideo({ body, contentId }) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().put(
    `/experts/${expertId}/contents/${contentId}`,
    body
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function editRejectedExpertVideo({ body, contentId }) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().put(
    `/experts/${expertId}/contents-updates/${contentId}`,
    body
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function cancelModifiedVideoUpdate(contentId) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().delete(
    `/experts/${expertId}/contents-updates/${contentId}`
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function getContents() {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API0().get(`/experts/${expertId}/contents`);
  return response?.result?.data?.contents;
}

export async function deleteNotes({ farmerId, id }) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().delete(
    `/experts/${expertId}/farmers/${farmerId}/notes/${id}`
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function addNewNote({ farmerId, note }) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().post(
    `/experts/${expertId}/farmers/${farmerId}/notes`,
    { note: note }
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function editNote({ farmerId, id, note }) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().put(
    `/experts/${expertId}/farmers/${farmerId}/notes/${id}`,
    { note: note }
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function getAllPlans() {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API0().get(`/experts/${expertId}/questionnaires`);
  return response?.result?.data;
}

export async function getAllVisits() {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API0().get(`/experts/${expertId}/visits`);
  return response?.result?.data;
}

export async function getExpertData() {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API0().get(`/experts/${expertId}`);
  return response?.result?.data;
}

//* statics

export async function getStaticExpertFields() {
  const response = await API0().get("/statics/experts-fields");
  return response?.result?.data?.expertsFields;
}

export async function getStaticProvinces() {
  const response = await API0().get("/statics/provinces");
  return response?.result?.data?.provinces;
}

export async function getStaticCitis() {
  const response = await API0().get("/statics/cities");
  return response?.result?.data?.cities;
}

export async function getProducts() {
  const response = await API0().get("/statics/products");
  return response?.result?.data?.products;
}

//* update expert

export async function updateExpert(expertData) {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().put(`/experts/${expertId}`, expertData);
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function customFilterQuestionnaires(
  productId,
  yearValue,
  stateId
) {
  let params = {};
  if (productId) params["pid"] = productId;
  if (stateId) params["state"] = stateId;
  if (yearValue) params["createdAt"] = yearValue;

  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API0().get(`/experts/${expertId}/questionnaires`, {
    params: params,
  });
  params = {};
  if (response) {
    return response;
  } else {
    throw Error();
  }
}

export async function customFilterVisits(productId, yearValue, stateId) {
  let params = {};
  if (productId) params["pid"] = productId;
  if (stateId) params["state"] = stateId;
  if (yearValue) params["createdAt"] = yearValue;

  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API0().get(`/experts/${expertId}/visits`, {
    params: params,
  });
  params = {};
  if (response) {
    return response;
  } else {
    throw Error();
  }
}

export async function getPrivateLink(bucket) {
  const response = await API0().get(`/files/${bucket}`);
  return response?.result?.data?.url;
}

export async function frogetPassword(data) {
  const response = await API1().post("/auth/reset-password", data);
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function logout() {
  const response = await API0().delete("/auth/logout");
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function getExpertProfile() {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API0().get(`/experts/profile/${expertId}`);
  return response?.result?.data;
}

export async function deleteModify() {
  const expertId =
    Cookies.get("expertId") || JSON.parse(localStorage.getItem("profile"))?.uid;
  const response = await API1().delete(`/experts/${expertId}/modified`);
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

//wordpress
export async function getMyArticles() {
  const expertProfile = JSON.parse(localStorage.getItem("profile"));

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_WORDPRESS_BLOG_URL}posts?author=${expertProfile.wordpressAuthorId}&_fields=id,title,link,_links,_embedded,content,status,date&status=publish,draft,pending&_embed&per_page=100`,
      {
        headers: {
          Authorization: `Basic ${expertProfile.wordpressAuthorToken}`,
        },
      }
    );
    //TODO check if response is not available
    return response?.data;
  } catch (error) {
    toast.error(error?.response?.data?.message);
    throw Error();
  }
}

export async function sendFeaturedImage({file, config}) {

  const expertProfile = JSON.parse(localStorage.getItem("profile"));

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_WORDPRESS_BLOG_URL}media`, file,
      {
        onUploadProgress: config?.onUploadProgress,
        headers: {
          Authorization: `Basic ${expertProfile.wordpressAuthorToken}`,
          "Content-Type": `image/${file.type}`,
          "Content-Disposition": `attachment; filename=${file.name}`,
        },
      },
    );
    if (response) {
      return response;
    } else {
      toast.error("مشکلی پیش آمده است");
      throw Error();
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
    throw Error();
  }
}

export async function deleteFeaturedImage(mediaId) {
  const expertProfile = JSON.parse(localStorage.getItem("profile"));

  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_WORDPRESS_BLOG_URL}media/${mediaId}?force=true`,
      {
        headers: {
          Authorization: `Basic ${expertProfile.wordpressAuthorToken}`,
          "Content-Type": "application/json",
        },
      },
    );
    if (response) {
      return response;
    } else {
      toast.error("مشکلی پیش آمده است");
      throw Error();
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
    throw Error();
  }
}

export async function createPost(postData) {
  const expertProfile = JSON.parse(localStorage.getItem("profile"));
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_WORDPRESS_BLOG_URL}posts`,
      postData,
      {
        headers: {
          Authorization: `Basic ${expertProfile.wordpressAuthorToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response) {
      toast.success("مقاله با موفقیت پیش نویس شد");
      return response;
    } else {
      toast.error("مشکلی پیش آمده است");
      throw Error();
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
    throw Error();
  }
}

export async function updatePost({ postData, id }) {
  const expertProfile = JSON.parse(localStorage.getItem("profile"));

  delete postData["id"];
  delete postData["status"];

  const response = await axios.post(
    `${process.env.REACT_APP_WORDPRESS_BLOG_URL}posts/${id}`,
    postData,
    {
      headers: {
        Authorization: `Basic ${expertProfile.wordpressAuthorToken}`,
        "Content-Type": "application/json",
      },
    }
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function getPostComments(postId) {
  // const expertProfile = JSON.parse(localStorage.getItem("profile"));

  // const response = await axios.get(
  //     `${process.env.REACT_APP_WORDPRESS_BLOG_URL}comments?post=${postId}&status=all&per_page=100`,
  //     {
  //       headers: {
  //         'Authorization': `Basic ${expertProfile.wordpressAuthorToken}`,
  //       }
  //     }
  // );
  // return response?.data;

  return [
    {
      id: 1,
      // showReplyBtn: false,
      selfComment: true,
      // author: _?.author,
      author_avatar_urls: {
        96: "https://s3.ir-thr-at1.arvanstorage.ir/iranexpert/experts/934f2fd8-4827-41bb-8bd4-599362aeea3b/1693820946653-doctor.png",
      },
      author_email: "test@email.com",
      //   JSON.parse(localStorage.getItem("profile"))["firstName"] +
      //   " " +
      //   JSON.parse(localStorage.getItem("profile"))["lastName"],
      author_name: "مجتبی حسینیان",
      // post: _?.post,
      content: {
        rendered:
          "این یک پیام تست برای بررسی عملکرد صحیح بخش کامنت های داشبورد کارشناس میباشد از این رو بدیهیست که وجود هرگونه مشکل یا ایراد در پیام طبیعی بوده و جای نگرانی ندارد",
      },
      // status: 'approved',
      status: "draft",
      // parent: _?.parent,
      date: "",
    },
    {
      id: 2,
      // showReplyBtn: false,
      selfComment: false,
      // author: _?.author,
      author_avatar_urls: {
        96: "https://s3.ir-thr-at1.arvanstorage.ir/iranexpert/experts/934f2fd8-4827-41bb-8bd4-599362aeea3b/1693820946653-doctor.png",
      },
      author_email: "test@email.com",
      //   JSON.parse(localStorage.getItem("profile"))["firstName"] +
      //   " " +
      //   JSON.parse(localStorage.getItem("profile"))["lastName"],
      author_name: "سید مصطفی مهدویان فر اصل",
      // post: _?.post,
      content: {
        rendered:
          "این یک پیام تست برای بررسی عملکرد صحیح بخش کامنت های داشبورد کارشناس میباشد از این رو بدیهیست که وجود هرگونه مشکل یا ایراد در پیام طبیعی بوده و جای نگرانی ندارد",
      },
      // status: 'approved',
      status: "draft",
      // parent: _?.parent,
      date: "",
    },
  ];
}

export async function sendComment(commentData) {
  const expertProfile = JSON.parse(localStorage.getItem("profile"));

  const response = await axios.post(
    `${process.env.REACT_APP_WORDPRESS_BLOG_URL}comments`,
    commentData,
    {
      headers: {
        Authorization: `Basic ${expertProfile.wordpressAuthorToken}`,
        "Content-Type": "application/json",
      },
    }
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function approveComment(commentId) {
  const expertProfile = JSON.parse(localStorage.getItem("profile"));

  const response = await axios.post(
    `${process.env.REACT_APP_WORDPRESS_BLOG_URL}comments/${commentId}`,
    { status: "approved" },
    {
      headers: {
        Authorization: `Basic ${expertProfile.wordpressAuthorToken}`,
        "Content-Type": "application/json",
      },
    }
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}

export async function deleteComment(commentId) {
  const expertProfile = JSON.parse(localStorage.getItem("profile"));

  const response = await axios.delete(
    `${process.env.REACT_APP_WORDPRESS_BLOG_URL}comments/${commentId}`,
    {
      headers: {
        Authorization: `Basic ${expertProfile.wordpressAuthorToken}`,
        "Content-Type": "application/json",
      },
    }
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw Error();
  }
}
//
